import Raven from 'raven-js'
import RavenVue from 'raven-js/plugins/vue'

const RavenPlugin = {
  install(Vue, options = {}) {
    if (import.meta.env.MODE !== 'development') {
      Raven.config(options.url)
        .addPlugin(RavenVue, Vue)
        .install()

      Vue.prototype.$Raven = Raven
    }
  },
}

export default RavenPlugin
